import i18n from '../locales/index'
/**
 *切换webview
 */
export const openUrlOnBrowser = () => {
  console.log('开始调用openUrlOnBrowser')
  if (window.require) {
    const { ipcRenderer } = window.require('electron');
    if (ipcRenderer) {
      console.log('调用了openUrlOnBrowser')
      ipcRenderer.send('toSales');
    }
  }
}

/**
 * 退到桌面
 */
export const minimizeWindow = () => {
  if (window.require) {
    const { ipcRenderer } = window.require('electron');
    if (ipcRenderer) {
      ipcRenderer.send('minimizeWindow');
    }
  }
}
